import React, {useState} from 'react'
import { Page, TextInput, FilterInput } from '@fielded/shared-ui'
import { filterByProp } from '@fielded/shared-ui/src/components/FilterInput'
import ShipmentHeader from '../common/ShipmentHeader'
import CountProduct from '../count/CountProduct'
import ProgressButton from '../common/ProgressButton'
import { canViewBatchInfo } from '../common/utils'

const filterProducts = (products, filterValue) => {
  if (!filterValue || filterValue === '') return products
  return filterByProp(products, filterValue, 'name')
}

const ReturnShipment = ({
  title,
  shipment,
  fractionChecked,
  config,
  batches,
  handleCountUpdate,
  canReturnQuantity,
  handleProceed,
  comment,
  onCommentChange
}) => {
  const [productFilterValue, setProductFilterValue] = useState('')

  const filteredProducts = filterProducts(batches, productFilterValue)
  const canViewBatch = canViewBatchInfo(config)

  return (
    <Page>
      <ShipmentHeader
        title={title}
        shipment={shipment}
        config={config}
        hideMeta
        isReturn
      />
      <Page.Intro>
        Enter quantities to be returned and check off products when done.
      </Page.Intro>
      <Page.Panel withMargin spread>
        <Page.Panel.Section>
          <FilterInput
            placeholder='Find product …'
            value={productFilterValue}
            onValueChange={setProductFilterValue}
          />
        </Page.Panel.Section>
        <Page.Panel.Section>
          { filteredProducts.length && filteredProducts.map(product => {
            product.id = product.batchId
            product.picked = product.quantity // CountProduct component expect picked as quantity in case of return shipment it's just quantity
            return (
              <div
                className='count__card-slot'
                key={product.productId}
              >
                <CountProduct
                  {...product}
                  canViewBatch={canViewBatch}
                  isChecked={product.checked}
                  onToggleChecked={handleCountUpdate}
                  dontShowDiff
                />
              </div>
            )
          })}
        </Page.Panel.Section>
        {!filteredProducts.length && (
          <Page.Panel.Section>
              No products found {productFilterValue && `matching "${productFilterValue}"`}
          </Page.Panel.Section>
        )}
        <Page.Panel.Section>
          <span>If you have any comment, please note it here.</span>
          <TextInput
            className='confirmation-commment__input'
            name='comment'
            value={comment}
            onChange={onCommentChange}
            rows={5}
          />
        </Page.Panel.Section>
      </Page.Panel>
      <Page.Footer layout='centered'>
        <ProgressButton
          onClick={handleProceed}
          isComplete={fractionChecked.checked === fractionChecked.total}
          progressText={`${fractionChecked.checked} of ${fractionChecked.total}`}
          progressSupportingText='products delivered'
          disabled={!canReturnQuantity}
          submitLabelText='Proceed'
        />
      </Page.Footer>
    </Page>
  )
}

export default ReturnShipment
